<style>
    .customDropdown{
        float: left;
        margin-right: 10px;
    }
    .blockText{
        margin: 15px;
        background: lightgray;
        width: 80%;
        padding: 4px;
        border-radius: 4px;
    }
</style>
<div class="row searchRow" style="margin-top: 20px;">
    <div class="col-sm-6">
        <div class="blockText">From :</div>
        <span class="col-sm-3">
            <div>Tax Year:</div>
            <select class="form-control input-sm customDropdown" 
                    [(ngModel)]="selectedFromTaxYear" 
                    (ngModelChange)="fromTaxYearChange($event)">
                @for (taxYear of taxYearsList; track $index) {
<option [ngValue]="taxYear">
                    {{taxYear.label}}
                </option>
}
            </select>
        </span>
        <span class="col-sm-3">
            <div>Scenario:</div>
            <select class="form-control input-sm customDropdown" 
                    [(ngModel)]="selectedFromScenario"
                    [disabled]="fromTaxYearFlag">
                @for (scenario of FromScenarioList; track $index) {
<option [ngValue]="scenario">
                    {{scenario.LABEL}}
                </option>
}
            </select>
        </span>
        <span class="col-sm-4">
            <div>Filing Group:</div>
            <select class="form-control input-sm customDropdown" 
                    [(ngModel)]="selectedFromFilingGroup"
                    [disabled]="fromTaxYearFlag">
                @for (fg of FromFilingGroupList; track $index) {
<option [ngValue]="fg">
                    {{fg.LABEL}}
                </option>
}
            </select>
        </span>
        <span class="col-sm-2">
            <!-- Reserved for future use -->
        </span>
    </div>

    <div class="col-sm-6">
        <div class="blockText">To :</div>
        <span class="col-sm-3">
            <div>Tax Year:</div>
            <select class="form-control input-sm customDropdown" 
                    [(ngModel)]="selectedToTaxYear" 
                    (ngModelChange)="toTaxYearChange($event)">
                @for (taxYear of taxYearsList; track $index) {
<option [ngValue]="taxYear">
                    {{taxYear.label}}
                </option>
}
            </select>
        </span>
        <span class="col-sm-3">
            <div>Scenario:</div>
            <select class="form-control input-sm customDropdown" 
                    [(ngModel)]="selectedToScenario"
                    [disabled]="toTaxYearFlag">
                @for (scenario of ToScenarioList; track $index) {
<option [ngValue]="scenario">
                    {{scenario.LABEL}}
                </option>
}
            </select>
        </span>
        <span class="col-sm-4">
            <div>Filing Group:</div>
            <select class="form-control input-sm customDropdown" 
                    [(ngModel)]="selectedToFilingGroup"
                    [disabled]="toTaxYearFlag">
                @for (fg of ToFilingGroupList; track $index) {
<option [ngValue]="fg">
                    {{fg.LABEL}}
                </option>
}
            </select>
        </span>
        <span class="col-sm-2">
            <button class="btn btn-info btn-sm" 
                    style="padding: 20px;" 
                    (click)="copySelectedChanges()"
                    [disabled]="showJsonLoader">
                @if (showJsonLoader) {
<span>
                    <i class="fa fa-spinner fa-spin"></i>
                </span>
}
                @if (!showJsonLoader) {
<span>Copy</span>
}
            </button>
        </span>
    </div>
</div>

